import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.606 24H3.395a3.76 3.76 0 0 1-2.53-1.394 3.96 3.96 0 0 1-.85-2.815v-9.144a4.7 4.7 0 0 1 .43-1.954c.28-.61.69-1.15 1.2-1.578L8.68 1.22A5.17 5.17 0 0 1 12.007 0c1.212 0 2.387.431 3.326 1.22l7.011 5.846c.513.425.927.964 1.211 1.575.284.61.431 1.28.431 1.957v9.205a3.96 3.96 0 0 1-.855 2.807A3.76 3.76 0 0 1 20.606 24",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("rect", {
      width: "6.857",
      height: "5.714",
      x: "14.857",
      y: "11.43",
      fill: "#fff",
      rx: "1.5",
      transform: "rotate(90 14.857 11.43)"
    }, null, -1)
  ])))
}
export default { render: render }